export default __webpack_public_path__ + "static/media/Fernanda.aa36759d.jpg";